import { contexData } from "@/store";
import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Input, Checkbox } from "antd";
import { get } from "lodash";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { isMobile } from "../../../utils/common";
import { InputWapper } from "../../../utils/helper";
import "./index.less";
import { language } from "@/utils/language";
import classNames from "classnames";
// 单行开放题
export default function BaseInput(props) {
  const { info = {}, answer = {}, changeAnswer, info2, themeId, isMinimalTheme } = props;
  const { infoContex } = useContext(contexData); //解构得到属性
  const [checkboxId, setCheckboxId] = useState(null)
  const [open10Id, setOpen10Id] = useState([]);

  const minimalTheme =
      Number(themeId || info?.themeId) === 4 || !!isMinimalTheme;

  let OPTIONCOLUMNS = get(info, "preferences.optionPrefer.optionsColumns", 1);

  let optionSumView = get(info, "preferences.optionPrefer.optionSumView", '');
  let optionUnit = get(info, "preferences.optionPrefer.optionUnit", '');

  let optionSumType = get(info, "preferences.optionPrefer.optionSumType", '');

  if (!OPTIONCOLUMNS) OPTIONCOLUMNS = 1;
  let optionForm2 = get(info, "childPrefer.optionForm", 1);
  if (optionForm2 == 4) {
    OPTIONCOLUMNS = get(info, "optionPrefer.optionsColumns", 1);
  }
  const [options] = useState(() => {
    const options = info.options || [];
    let isModuleCollection = false;
    const newOptions = [];
    let index = 0;
    for (let i = 0; i < options.length; i++) {
      if (+options[i].moduleOption === 3) {
        isModuleCollection = true;
        index = i;
        newOptions.push(options[i]);
      } else if (+options[i].moduleOption !== 0) {
        isModuleCollection = false;
      }
      if (isModuleCollection) {
        if (index !== i) {
          const oldChildrenOption =
            newOptions[newOptions.length - 1].childrenOption || [];
          newOptions[newOptions.length - 1].childrenOption = [
            ...oldChildrenOption,
            options[i],
          ];
        }
      } else {
        newOptions.push(options[i]);
      }
    }
    return newOptions;
  });
  const [collapseStatus, setCollapseStatus] = useState(() => {
    return (info.options || [])
      .filter((item) => +item.moduleOption === 3)
      .reduce((acc, current) => {
        return {
          ...acc,
          [current.id]: false,
        };
      }, {});
  });

  const width = useMemo(() => {
    let OPTIONCOLUMNS = get(info, "preferences.optionPrefer.optionsColumns", 1);
    if (!OPTIONCOLUMNS) OPTIONCOLUMNS = 1;

    let width = 100;
    if (isMobile) {
      if (OPTIONCOLUMNS > 3) {
        OPTIONCOLUMNS = 3;
      }
      width = 99 / OPTIONCOLUMNS;
    }
    width = 99 / OPTIONCOLUMNS;
    return width + "%";
  }, [info]);
  const [total, setTotal] = useState(0)

  const onChange = (id, value) => {
    let _aws = {
      ...answer[info.id],
      [id]: {
        text: value || null,
      }
    }
    // let numorfloatList = options.filter(it => it.open == 2 || it.open == 3).map(i=>i.id)
    // // { name: "数字", id: 2 },
    // // { name: "整数", id: 3 },
    // let numbersTotal;
    // if(optionSumView){
    //   numbersTotal = Object.keys(_aws).filter(item => {
    //     return numorfloatList.includes(item)
    //    }).map(item=> +(_aws[item].text)).reduce((prev, curr) => {
    //      return  parseFloat((prev+ curr).toFixed(10))
    //    })
    // }
    // setTotal(numbersTotal)
    changeAnswer(_aws);
  };

  useEffect(() => {
    try {
      let numbersTotal;
      if (optionSumView && JSON.stringify(answer) !== "{}") {
        let numorfloatList = options.filter(it => it.open == 2 || it.open == 3).map(i => i.id)
        numbersTotal = Object.keys(answer[info.id]).filter(item => {
          return numorfloatList.includes(item)
        }).map(item => +(answer[info.id][item].text)).reduce((prev, curr) => {
          return parseFloat((prev + curr).toFixed(10))
        })
      }
      setTotal(numbersTotal)
    } catch (error) {

    }

  }, [answer[info.id]])


  useEffect(() => {
    let _openIdList = info.options.filter(iitem => iitem.open == 10).map(iitem => iitem.id);

    setOpen10Id(_openIdList);
  }, [info.id])

  function isTruthyMutexValue(value) {
    if (value && typeof value === "object" && "text" in value) {
      value = value.text;
    }
    return value === true || value === "true" || value === 1 || value === "1";
  }

  function isDesible() {
    for (let i = 0; i < open10Id.length; i++) {
      const element = open10Id[i];
      if (isTruthyMutexValue(answer[info.id]?.[element])) {
        return true;
      }
      if (isTruthyMutexValue(answer[info.id]?.[element]?.text)) {
        return true;
      }
    }
    return false;
  }

  function buildNextAnswer(answerByQuestion, optionId, nextValue) {
    const nextAnswer = { ...(answerByQuestion || {}) };
    if (nextValue === undefined) {
      delete nextAnswer[optionId];
    } else {
      nextAnswer[optionId] = { text: nextValue };
    }
    return nextAnswer;
  }

  // 生成选项
  const getOptions = (options) => {
    if (options && options.length > 0) {
      return (
        <React.Fragment>
          {options.map((option) => {
            if (+option.moduleOption === 2 || option.hide) return null;
            if (+option.moduleOption === 1) {
              return (
                <div
                  key={option.id}
                  className="q-content-module"
                  style={{

                    // background: "#bec6cd",
                    margin: "18px"
                  }}
                  dangerouslySetInnerHTML={{
                    __html: option.description
                      .replace(/<p><\/p>/g, "<br />")
                      .replace(/\n\n/g, "<br />")
                      .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                  }}
                />
              );
            }
            if (+option.moduleOption === 3) {
              return (
                <React.Fragment key={option.id}>
                  <div
                    className="q-content-module-collapse"
                    onClick={() => {
                      setCollapseStatus((state) => ({
                        ...state,
                        [option.id]: !collapseStatus[option.id],
                      }));
                    }}
                  >
                    {collapseStatus[option.id] ? (
                      <MinusCircleOutlined />
                    ) : (
                      <PlusCircleOutlined />
                    )}
                    <div
                      style={{ color: infoContex.preferences?.optionColour }}
                      dangerouslySetInnerHTML={{
                        __html: option.description
                          .replace(/<p><\/p>/g, "<br />")
                          .replace(/\n\n/g, "<br />")
                          .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                      }}
                    />
                  </div>
                  {collapseStatus[option.id] &&
                    option.childrenOption.map((childOption) => (
                      <div
                        key={childOption.id}
                        className="q-content-option"
                        style={{ width }}
                      >
                        <div
                          className="option-text"
                          style={{
                            color: infoContex.preferences?.optionColour,
                          }}
                          dangerouslySetInnerHTML={{
                            __html: childOption.description,
                          }}
                        />
                        <InputWapper unit={option.unit}>
                          <Input

                            style={
                              option.width > 0 && option.height > 0
                                ? {
                                  width: `${option.width}px`,
                                  height: `${option.height}px`,
                                  lineHeight: `${option.height}px`,
                                }
                                : {}
                            }
                            disabled={isDesible() || option.fixed == 1}
                            className="option-input"
                            placeholder={language().input_placeholder}
                            value={answer?.[info.id]?.[childOption.id]?.text}
                            onChange={(e) => {
                              onChange(childOption.id, e.target.value);
                            }}
                          />
                        </InputWapper>

                      </div>
                    ))}
                </React.Fragment>
              );
            }


            return (
              <div
                key={option.id}
                className="q-content-option"
                style={{ width, marginBottom: option.open == 10 ? 19 : 30 }}
              >
                {option.open !== 10 && <div
                  className="option-text"
                  style={{ color: infoContex.preferences?.optionColour }}
                  dangerouslySetInnerHTML={{
                    __html: option.description
                      .replace(/<p><\/p>/g, "<br />")
                      .replace(/\n\n/g, "<br />")
                      .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                  }}
                />}
                <section>
                  {option.open == 10 ?
                    <Checkbox style={{}} checked={!!answer[info.id]?.[option.id]?.text} onChange={(e) => {
                      const nextValue = e.target.checked ? "true" : undefined;
                      const nextAnswer = buildNextAnswer(
                        answer[info.id],
                        option.id,
                        nextValue
                      );
                      changeAnswer(nextAnswer);
                    }}>
                      <div
                        className="option-text"
                        style={{ color: infoContex.preferences?.optionColour }}
                        dangerouslySetInnerHTML={{
                          __html: option.description
                            .replace(/<p><\/p>/g, "<br />")
                            .replace(/\n\n/g, "<br />")
                            .replace(/\s{2}/g, "&nbsp;&nbsp;"),
                        }}
                      />
                    </Checkbox> :
                    <InputWapper unit={option.unit}>
                      <Input
                        style={
                          option.width > 0 && option.height > 0
                            ? {
                              width: `${option.width}px`,
                              height: `${option.height}px`,
                              lineHeight: `${option.height}px`,
                            }
                            : {}
                        }
                        disabled={isDesible() || option.fixed == 1}
                        className="option-input"
                        placeholder={language().input_placeholder}
                        value={answer[info.id]?.[option.id]?.text}
                        onChange={(e) => {
                          onChange(option.id, e.target.value);
                        }}
                      />
                    </InputWapper>
                  }

                </section>

              </div>
            );
          })}
        </React.Fragment>
      );
    }

    return null;
  };
  const InptutTotal = () => {
    let result = [];
    let totalAnswer = JSON.parse(JSON.stringify(answer));
    let f = false;
    open10Id.forEach(element => {
      if (answer[info.id]?.[element]?.text) {
        f = true;
      }
    });
    if (f) {
      return 0
    }
    if (totalAnswer[info.id]) {
      open10Id.forEach(element => {
        delete totalAnswer[info.id][element]
      });

      const result = Object.values(totalAnswer[info.id]);
      return result.reduce((acc, obj) => acc + Number(obj.text), 0);
    }
    return result.reduce((acc, obj) => acc + Number(obj.text), 0);
  }

  return (
      <div className={classNames("base-input", {"theme-minimal": minimalTheme})}>
        <div className={classNames("q-content", {"theme-minimal": minimalTheme})}>
          <div className="q-content-options">{getOptions(options)}
            <>
              {!!(info2?.preferences?.optionPrefer?.optionSumView ||
                      info.preferences?.optionPrefer?.optionSumView)
                  &&
                  <span>{language().total}: {InptutTotal()} {info2?.preferences?.optionPrefer?.optionUnit || optionUnit || ""} </span>}
            </>
          </div>
        </div>
      </div>
  );
}

